// True when a unit is the generic base "Each" (which we never surface in the UI).
export const isEachUnit = (u) => !u || String(u).trim().toLowerCase() === "each";

// Total current available stock across ALL of a product's UOM/variant records.
// When a product has variants, each variant tracks its OWN independent in_stock, so we sum them
// (never double-count the parent). Only products with no variants fall back to the base stock.
// This is the single source of truth for POS/Products availability so a product is only "OUT"
// when EVERY variant is 0 — not just because the default variant happens to be empty.
export function totalStock(p) {
  if (!p) return 0;
  const uoms = p.uoms || [];
  if (uoms.length > 0) return uoms.reduce((s, u) => s + (u.in_stock != null ? Number(u.in_stock) || 0 : 0), 0);
  return Number(p.stock) || 0;
}

// Resolve the product's active/default VARIANT view (identity + independent stock).
// The base "Each" unit is intentionally NOT surfaced as a selectable variant: when a
// product has alternate variants we show the chosen default variant (or the first one).
// Only products with NO alternate variants fall back to the base unit.
export function defaultView(p) {
  if (!p) return { unit: "Each", isBase: true, brand: "", part_number: "", cost: 0, price: 0, msrp: 0, in_stock: 0 };
  const base = p.base_unit || "Each";
  const dfl = p.default_uom || "";
  const alts = p.uoms || [];
  let u = dfl && dfl !== base ? (alts.find((x) => x.id === dfl) || alts.find((x) => x.unit === dfl)) : null;
  if (!u && alts.length > 0) u = alts[0];
  if (!u) {
    return { unit: base, isBase: true, brand: p.brand || "", part_number: p.part_number || "", cost: Number(p.cost) || 0, price: Number(p.price) || 0, msrp: Number(p.msrp) || 0, in_stock: Number(p.stock) || 0 };
  }
  const f = Number(u.factor) || 1;
  const inStock = u.in_stock != null ? Number(u.in_stock) : (f > 0 ? Math.floor((p.stock || 0) / f) : 0);
  return { unit: u.unit, isBase: false, brand: u.brand || "", part_number: u.part_number || "", cost: Number(u.cost) || 0, price: Number(u.price) || 0, msrp: Number(u.msrp) || 0, in_stock: inStock };
}
